import React, { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4090';

const PlanContext = createContext({
  plan: null,
  loading: true,
  hasFeature: () => false,
  refetch: () => {}
});

export function PlanProvider({ children }) {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  // Renvoie le plan chargé : la page Facturation vérifie après un paiement que
  // l'activation est bien visible (vague 3), ce qu'un simple setState ne permet
  // pas de savoir dans la foulée.
  async function loadPlan() {
    try {
      const res = await axios.get(`${API}/api/v2/plans/me`);
      setPlan(res.data);
      return res.data;
    } catch (err) {
      console.warn('[PlanContext] fallback basic — /api/v2/plans/me failed:', err?.message || err);
      const fallback = { currentPlan: 'basic', features: [] };
      setPlan(fallback);
      return fallback;
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadPlan();
  }, []);

  function hasFeature(featureName) {
    if (!plan) return false;
    return plan.features.includes(featureName);
  }

  return (
    <PlanContext.Provider value={{ plan, loading, hasFeature, refetch: loadPlan }}>
      {children}
    </PlanContext.Provider>
  );
}

export function usePlan() {
  return useContext(PlanContext);
}
